import { REPORT_STATUS } from "@/constants/report";
import { userModel } from "@/models/api/user.model";

export const reportModel = (data = {}) => ({
  uuid: data.uuid,
  type: Number(data.type),
  description: data.description || "",
  platformType: Number(data.platform_type),
  status: Number(data.status),
  user: data.user ? userModel(data.user) : null,
  createdAt: data.created_at || null,
  createdBy: data.created_by || null,
  updatedAt: data.updated_at || null,
  updatedBy: data.updated_by || null,
});

export const isReportEditable = (report) =>
  [REPORT_STATUS.SUBMITTED, String(REPORT_STATUS.SUBMITTED)].includes(
    report?.status,
  );
